import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  table: {
    width: '100%',
    backgroundColor: theme.palette.black.lighter,
  },
  tableBody: {
    position: 'relative',
  },
  loader: {
    position: 'absolute',
    left: '55%',
    top: '55%',
  },
  cell: {
    padding: theme.spacing(1.75),
    borderBottom: `${theme.spacing(0.125)}px solid ${theme.palette.black.light}`,
    ...theme.typography.h6,
    backgroundColor: theme.palette.gray.dark,
  },
  emptyCell: {
    border: 'none',
    backgroundColor: theme.palette.black.lighter,
  },
  pagination: {
    '& .MuiTablePagination-spacer': {
      flex: 'unset',
    },
    '& .MuiTablePagination-caption': {
      order: -1,
      color: theme.palette.gray.main,
      ...theme.typography.h6,
    },
    '& .MuiTablePagination-select': {
      border: `${theme.spacing(0.125)}px solid ${theme.palette.gray.main}`,
      padding: theme.spacing(0.5, 2.125, 0.5, 0.75),
      textAlign: 'left',
      textAlignLast: 'left',
      minWidth: theme.spacing(1.5),
      color: theme.palette.gray.main,
      ...theme.typography.h6,
    },
    '& .MuiTablePagination-selectIcon': {
      color: theme.palette.gray.main,
    },
  },
  csvLink: {
    textDecoration: 'none',
  },
  csvButtonContainer: {
    padding: theme.spacing(2),
  },
  csvButton: {
    backgroundColor: theme.palette.gray.dark,
  },
  clickable: {
    cursor: 'pointer',
  },
}));
